export const ALL_POINTER = 'all'

export default class NotificationDataModel {
  constructor(data) {
    this.data = data
  }
  
  notificationsData() {
    return this.data.notifications.map(notification => {
      const category = this.data.categories.filter(item => item.category.id === notification.category_id)
      const categoryIconUrl = category.length === 0 ? null : category[0].category.icon_url
      return { category_icon_url: categoryIconUrl, ...notification }
    })
  }

  notificationsByCategoryId(id) {
    return id === ALL_POINTER
      ? this.notificationsData() 
      : this.notificationsData().filter(item => item.category_id === id)
  }
}
